<ol class="breadcrumb">
  <li *ngFor="let breadCrumb of breadCrumbs$ | async; last as isLast">
    <a
      *ngIf="breadCrumb.label"
      [ngClass]="{ 'link-disabled': isLast }"
      (click)="onClick(breadCrumb)"
      >{{ breadCrumb.label }}</a
    >
  </li>
</ol>
